export default __webpack_public_path__ + "static/media/logo.526aae58.svg";